// TOREFACTO :
// - Add isOms logic to this part (remove all files from oms.orderItemPage) and merge it with this new version
import { useState } from "react";
import { WorkflowPostponedActivityReadDtoActivityEnum } from "@/config/apiClient";
import { OrderItemLogActionTypeEnum } from "@/config/apiClient.types";
import { getIsSelectedDateInProductionTime } from "@/helpers/dates/getIsSelectedDateIsInProductionTime";
import { usePageTemplate } from "@/hooks/utils";
import { type OrderItemDetailsProps } from "./OrderItemDetails.types";
import { OrderItemDetailsContent } from "./OrderItemDetailsContent";
import { OrderItemDetailsHeader } from "./OrderItemDetailsHeader";

export const OrderItemDetails = ({
  order,
  orderItem,
  isLoading,
  handleRefetchOrderItemDetails,
}: OrderItemDetailsProps) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const { PageTemplateV2, isScrolled } = usePageTemplate();

  const hasAModificationRequest = orderItem?.Workflow.PostponedActivities.some(
    (postponedActivity) =>
      postponedActivity.activity ===
      WorkflowPostponedActivityReadDtoActivityEnum.DecideOnModificationRequest
  );

  const orderedLogsByCreationDateDesc = orderItem?.OrderLog.filter(
    (log) =>
      log.actionType === OrderItemLogActionTypeEnum.PLACED ||
      log.actionType === OrderItemLogActionTypeEnum.RUSH_ORDER_ACCEPTED_DATE ||
      log.actionType === OrderItemLogActionTypeEnum.RUSH_ORDER_NEW_DATE_PROPOSAL
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  const isRushOrder =
    orderedLogsByCreationDateDesc?.[0]?.actionType ===
      OrderItemLogActionTypeEnum.PLACED &&
    orderItem?.sandboxItem.deliveryDate &&
    orderItem?.sandboxItem.productionTime &&
    getIsSelectedDateInProductionTime(
      new Date(orderItem.sandboxItem.deliveryDate),
      orderItem.sandboxItem.productionTime
    );

  const isRushOrderUIDisplayed =
    isRushOrder && orderItem?.status !== "CANCELLED";

  // TOREFACTO : Loading state ?
  if (!orderItem || !order) {
    return null;
  }

  return (
    <PageTemplateV2>
      <PageTemplateV2.Header>
        <OrderItemDetailsHeader
          handleCancelModalOpen={setIsCancelModalOpen}
          hasAModificationRequest={hasAModificationRequest}
          isLoading={isLoading}
          isScrolled={isScrolled}
          order={order}
          orderItem={orderItem}
          isRushOrderUIDisplayed={!!isRushOrderUIDisplayed}
        />
      </PageTemplateV2.Header>
      <PageTemplateV2.Content px="sp-xl3" py="sp-xl">
        <OrderItemDetailsContent
          isRushOrderUIDisplayed={!!isRushOrderUIDisplayed}
          handleCancelModalOpen={setIsCancelModalOpen}
          hasAModificationRequest={hasAModificationRequest}
          isCancelModalOpen={isCancelModalOpen}
          isLoading={isLoading}
          order={order}
          orderItem={orderItem}
          handleRefetchOrderItemDetails={handleRefetchOrderItemDetails}
        />
      </PageTemplateV2.Content>
    </PageTemplateV2>
  );
};
